module.exports = __webpack_public_path__ + "user-research.3Soa75V2.svg";